module.exports = __webpack_public_path__ + "1_0_64/img/env.bcac2232.png";